import {isFeatureEnabled} from '@github-ui/feature-flags'
import {createContext, use} from 'react'

export const RepoIssuesSidebarLayoutEnabledContext = createContext<boolean | undefined>(undefined)

/**
 * Gates the new repo-issues sidebar/header layout on the
 * `repo_issues_sidebar_layout` (current_user-scoped) flag.
 */
export function useRepoIssuesSidebarLayoutEnabled(): boolean {
  return use(RepoIssuesSidebarLayoutEnabledContext) ?? isFeatureEnabled('repo_issues_sidebar_layout')
}
